import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import FeatherIcon from "feather-icons-react";

import { Link } from "react-router-dom";

import AuthLayout from "../../components/authenticate/AuthLayout";

const Register = (props) => {
  const [registerStatus, setregisterStatus] = useState(false)
  useEffect(() => {
    const registerStatus = localStorage.getItem("registerStatus")
    if (registerStatus === "true") {
     setregisterStatus(true)
    }
  }, [])
  return (
    <React.Fragment>
      <MetaTags>
        <title>Register | Glogix </title>
      </MetaTags>

      <AuthLayout
        footer={
          <>
            Don't have an account yet ? <Link to="/register">Register</Link>
          </>
        }
      >
        <div className="gx-auth-card">
          {registerStatus ? (
            <>
              <div className="gx-auth-title">
                <div className="gx-status-icon is-success">
                  <FeatherIcon icon="check" size={28} />
                </div>
                <h4>Registration Successful!</h4>
                <p>Login to continue to the Glogix Platform.</p>
              </div>
              <Link to="/login" className="btn btn-primary w-100">
                Login
                <FeatherIcon icon="arrow-right" size={16} className="ms-2" />
              </Link>
            </>
          ) : (
            <>
              <div className="gx-auth-title">
                <div className="gx-status-icon is-error">
                  <FeatherIcon icon="x" size={28} />
                </div>
                <h4>Registration Failed!</h4>
                <p>Please register again to continue to the Glogix Platform.</p>
              </div>
              <Link to="/register" className="btn btn-primary w-100">
                Register Again
              </Link>
            </>
          )}
        </div>
      </AuthLayout>
    </React.Fragment>
  );
};

export default Register;
